"use client"

import { Images } from "@/constants/images"
import { PostData } from "@/types/types"
import { Pagination } from "swiper/modules"
import { Swiper, SwiperSlide } from "swiper/react"

import type { CategoryConfig } from "../../../tamda-media/TamdaMediaNewsLayout/types/config"
import type { Article } from "../../../tamda-media/TamdaMediaNewsLayout/types/new"
import { CategorySidebar } from "./CategorySidebar"
import { NewsCard } from "./NewsCard"

import { SkeletonSwiperContent } from "@/(admin)/modules/ui-builder/config/themes/tamda-one/NewsSwiper/components/SkeletonSwiperContent"
import { t } from "@/languages/i18n"
import "swiper/css"
import "swiper/css/navigation"
import "swiper/css/pagination"
import "./paginationSwiper.css"

interface NewsSwiperContentProps {
  id: string
  title: string
  categories: CategoryConfig[]
  locale?: string
  posts: Article[]
  postsData: Map<string, PostData>
  slidesPerView: number
  spaceBetween: number
  loading: boolean
  selectedCategoryId?: string
  onCategoryClick: (categoryId: string) => void
  className?: string
}

export function NewsSwiperContent({
  id,
  title,
  categories,
  posts,
  postsData,
  locale = "vi",
  slidesPerView,
  spaceBetween,
  loading,
  selectedCategoryId,
  onCategoryClick,
  className = "",
}: NewsSwiperContentProps) {
  const safeCategories = Array.isArray(categories) ? categories : []

  return (
    <div id={id} className={`mx-auto max-w-[1290px] px-[15px] ${className}`}>
      <div className="flex sm:flex-row flex-col sm:gap-[30px] gap-[50px]">
        <CategorySidebar
          title={title}
          categories={safeCategories}
          selectedCategoryId={selectedCategoryId}
          onCategoryClick={onCategoryClick}
        />

        <div
          className="w-full sm:w-[82.9%] sm:relative"
          style={{
            backgroundImage: `url(${Images.bgLatestNews.src})`,
            backgroundRepeat: "no-repeat",
            backgroundPosition: "right",
          }}
        >
          {loading ? (
            <SkeletonSwiperContent />
          ) : posts.length > 0 ? (
            <Swiper
              spaceBetween={spaceBetween}
              slidesPerView={1}
              modules={[Pagination]}
              pagination={{
                clickable: true,
                dynamicBullets: true,
              }}
              breakpoints={{
                640: {
                  slidesPerView: 2,
                },
                1024: {
                  slidesPerView: 3.077,
                },
              }}
              className="news-swiper min-[768px]:w-[1180px]"
            >
              {posts.map(article => (
                <SwiperSlide key={article.id}>
                  <NewsCard article={article} postData={postsData.get(article.id)} locale={locale} />
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            <div className="text-center py-10 text-gray-500">{t("No posts found")}</div>
          )}
        </div>
      </div>
    </div>
  )
}
